import { ColorEnum } from '@/constants/color'
import PowerIcon from '@/features/ui/icons/components/PowerIcon'
import { FC } from 'react'
import { GestureResponderEvent, Pressable, StyleProp, StyleSheet, ViewStyle } from 'react-native'

interface AuthChangeLicenceIdIconButtonProps {
    onPress: () => void
    style?: StyleProp<ViewStyle>
}

const AuthChangeLicenceIdIconButton: FC<AuthChangeLicenceIdIconButtonProps> = ({
    onPress,
    style,
}) => {
    const handleButtonPress = (event: GestureResponderEvent) => {
        event.stopPropagation()
        onPress()
    }

    return (
        <Pressable onPress={handleButtonPress} style={[styles.button, style]}>
            <PowerIcon fill={ColorEnum.WHITE} />
        </Pressable>
    )
}

const styles = StyleSheet.create({
    button: {
        alignItems: 'center',
        justifyContent: 'center',
        width: 24,
        height: 24,
    },
})

export default AuthChangeLicenceIdIconButton
